import React from 'react';
import PropTypes from 'prop-types';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

class CreateTicketRadioGroup extends React.Component {

    constructor(props) {
        super(props);

        this.handlePmTicketRadioGroupChange = this
            .handlePmTicketRadioGroupChange
            .bind(this);

    }

    handlePmTicketRadioGroupChange(e, value) {
        const { workOrderActions, orderId, orderCloseDetails } = this.props;

        let comment = null;
        let exsistingTicket = null;

        const exsistingTickets = orderCloseDetails.getIn(['closeOrderRequest', 'ticketRequests']);

        if (exsistingTickets) {

            exsistingTicket = exsistingTickets.find((item) => {

                return item.get('workType') === 'Maintenance';

            });
        }

        if (exsistingTicket) {
            comment = exsistingTicket.get('comment');
        }

        if (value === 'yes') {
            workOrderActions.ticketRequestAdd({
                workType: 'Maintenance',
                customerImpacting: true,
                comment: comment
            }, orderId);
        }

        if (value === 'no') {
            workOrderActions.ticketRequestRemove('Maintenance', orderId);
        }
    }

    render() {
        const { orderCloseDetails, disabled } = this.props;

        let exsistingTicket = null,
            defaultSelectedHasPmTicket = 'no';

        if (orderCloseDetails.getIn(['closeOrderRequest', 'ticketRequests'])) {

            exsistingTicket = orderCloseDetails
                .getIn(['closeOrderRequest', 'ticketRequests'])
                .find((item) => {

                    return item.get('workType') === 'Maintenance';

                });

            if (exsistingTicket) {
                defaultSelectedHasPmTicket = 'yes';
            }

        }

        return (

            <div>

                <label>
                    Create Maintenance Ticket?</label>

                <RadioButtonGroup
                    style={{
                        display: 'flex',
                        flexDirection: 'row'
                    }}
                    onChange={this.handlePmTicketRadioGroupChange}
                    name="pmTicket"
                    valueSelected={defaultSelectedHasPmTicket}>
                    <RadioButton
                        disabled={disabled}
                        value="no"
                        label="No"
                        style={{
                            display: 'inline-block'
                        }} />
                    <RadioButton
                        disabled={disabled}
                        value="yes"
                        label="Yes"
                        style={{
                            display: 'inline-block'
                        }} />

                </RadioButtonGroup>
            </div>

        );

    }
}

CreateTicketRadioGroup.propTypes = {
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    disabled: PropTypes.bool
};

export default CreateTicketRadioGroup;


// WEBPACK FOOTER //
// ./src/components/ticket/CreateTicketRadioGroup.js